import { Contract, ethers } from 'ethers';
import abi from '../../abis/src/NFT/NFT.json';
import batchTransferAbi from '../../abis/src/NFT/BatchTransfer.json';
import { TRANSFER_CONTRACT_ADDRESS } from '@/constants';

export const getEthereumContract = async (
  collectionAddress,
  walletProvider,
  contractAbi,
) => {
  try {
    const provider = new ethers.providers.Web3Provider(walletProvider);
    const signer = provider.getSigner();
    const contract = new Contract(collectionAddress, contractAbi, signer);

    return contract;
  } catch (error) {
    return error;
  }
};

export const safeTransferFrom = async ({
  nftId,
  ownerAddress,
  receiverAddress,
  collectionAddress,
  walletProvider,
}) => {
  let success = false;

  try {
    const contract = await getEthereumContract(
      collectionAddress,
      walletProvider,
      abi,
    );

    const transaction = await contract[
      'safeTransferFrom(address,address,uint256)'
    ](ownerAddress, receiverAddress, nftId);

    await transaction.wait().then(() => (success = true));
    return success;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return false;
  }
};

export const batchTransfer = async ({
  walletProvider,
  receiverAddress,
  nftList,
}) => {
  try {
    const contract = await getEthereumContract(
      TRANSFER_CONTRACT_ADDRESS,
      walletProvider,
      batchTransferAbi.abi,
    );

    const collectionsAndTokens = nftList.reduce(
      (acc, item) => {
        const index = acc.collections.indexOf(item.collection_address);
        if (index === -1) {
          acc.collections.push(item.collection_address);
          acc.tokens.push([item.token_id]);
        } else {
          acc.tokens[index].push(item.token_id);
        }
        return acc;
      },
      { collections: [], tokens: [] },
    );

    const transaction = await contract.batchTransfer(
      collectionsAndTokens.collections,
      collectionsAndTokens.tokens,
      [],
      [],
      [],
      receiverAddress,
    );

    await transaction.wait();

    return true;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return false;
  }
};

export const requestTransferApproval = async ({
  nftList,
  walletProvider,
  walletAddress,
}) => {
  const transactionsList = [];

  try {
    const collectionAddresses = nftList.map((item) => item.collection_address);

    const uniqueAdressesArr = [...new Set(collectionAddresses)];

    for (const address of uniqueAdressesArr) {
      const contract = await getEthereumContract(address, walletProvider, abi);
      const approved = await contract.isApprovedForAll(
        walletAddress,
        TRANSFER_CONTRACT_ADDRESS,
      );

      if (!approved) {
        const transaction = await contract.setApprovalForAll(
          TRANSFER_CONTRACT_ADDRESS,
          true,
        );
        transactionsList.push(transaction.wait());
      }
    }

    const resolve = await Promise.all(transactionsList);

    if (resolve) {
      return true;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return false;
  }
};
